// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"e93bb224","256":"8000a28c","285":"aaedab4d","399":"8213eaaf","566":"ed42362f","607":"fcc1a80e","715":"a7ad0532","894":"fed2ac70"}[chunkId] + ".chunk.css";
};